import {LocationInventory} from '../types';

export const getLocationInventory = async (
  countryCode: string,
  productId?: string,
) => {
  const response = await fetch(`/api/location-inventory`, {
    method: 'POST',
    body: JSON.stringify({
      productId,
      countryCode,
    }),
  });

  const data = (await response.json()) as LocationInventory;

  return data;
};
